import { useCallback, useState } from "react";
import { useCopyToClipboard } from "../../../../hooks/index.js";
import { usePreviewTheme } from "../../context/StoredThemes.js";
function useThemeActions() {
  const {
    previewTheme,
    api: { setTheme },
    name,
    pristine
  } = usePreviewTheme();
  const [error, setError] = useState(false);
  const [, copyToClipboard] = useCopyToClipboard({
    onError: () => {
      setError(true);
    }
  });
  const handleDownload = useCallback(() => {
    download(JSON.stringify(previewTheme, null, 2), "theme.json", "application/json");
  }, [previewTheme]);
  const handleResetTheme = useCallback(() => {
    setTheme({});
  }, [setTheme]);
  const handleOnCopyToClipboard = useCallback(() => {
    copyToClipboard(JSON.stringify(previewTheme, null, 2));
  }, [copyToClipboard, previewTheme]);
  const handleCloseSnackbar = useCallback(() => {
    setError(false);
  }, []);
  return {
    handleCloseSnackbar,
    handleDownload,
    handleOnCopyToClipboard,
    handleResetTheme,
    pristine,
    snackBarOpen: error,
    themeName: name
  };
}
function download(content, fileName, contentType = "text/plain") {
  const a = document.createElement("a");
  const file = new Blob([content], { type: contentType });
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}
export {
  useThemeActions
};
//# sourceMappingURL=useThemeActions.js.map
